"use client";

import { cn } from "@/lib/utils";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle, Loader2 } from "lucide-react";

interface LoadingState {
  text: string;
}

export function MultiStepLoader({
  loadingStates,
  loading,
  currentState,
  className,
}: {
  loadingStates: LoadingState[];
  loading?: boolean;
  currentState: number;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      {loadingStates.map((state, index) => {
        const isActive = index === currentState;
        const isComplete = index < currentState;
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className="flex items-center gap-3"
          >
            {isComplete ? (
              <CheckCircle className="h-5 w-5 text-green-500" />
            ) : isActive ? (
              <Loader2 className="h-5 w-5 animate-spin text-primary" />
            ) : (
              <div className="h-5 w-5 rounded-full border-2 border-muted" />
            )}
            <span
              className={cn(
                "text-sm transition-colors",
                isActive && "font-medium text-foreground",
                isComplete && "text-muted-foreground",
                !isActive && !isComplete && "text-muted-foreground/50"
              )}
            >
              {state.text}
            </span>
          </motion.div>
        );
      })}
    </div>
  );
}
